import type {
  CreateProjectMembershipInput,
  ProjectMember,
  ProjectMembershipInviteResult,
  ProjectMembershipUserIdInput,
} from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createProjectMembershipClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    find: ({ projectId }: { projectId: string }) => {
      return request<ProjectMember[]>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/membership`,
      });
    },
    create: ({
      projectId,
      ...input
    }: { projectId: string } & CreateProjectMembershipInput) => {
      return request<ProjectMembershipInviteResult>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/membership/invite`,
        body: input,
      });
    },
    delete: ({
      projectId,
      ...input
    }: { projectId: string } & ProjectMembershipUserIdInput) => {
      return request<ProjectMember[]>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/membership/delete`,
        body: input,
      });
    },
  };
}
